import { useEffect, useState } from "react";
import AttendanceCard from "../components/common/attendance";
import { getRequest } from "../service/index";
import { Clock, NotebookIcon, SquareKanban, Users, Volume2 } from "lucide-react";
import EntryTable from "../components/common/missingentrytable";
import LeaveTable from "../components/common/leavetable";
import PaySlip from "../components/common/payslip-table";
import RequestTable from "../components/common/request-table";
import TeamTable from "../components/common/team-table";
import Announce from "../components/common/announce";
import Chart from "../charts/Chart";
import { getEmployeeId } from "../utils/localStorage";

const Dashboard = () => {
  
  const [attendanceData, setAttendanceData] = useState([]);
  const [salaryStatus, setSalaryStatus] = useState(true);
  const [teamData, setTeamData] = useState(null);
  
  useEffect(() => {
    const employeeId = getEmployeeId();
    console.log("salaryStatus",salaryStatus);
    async function fetchSalaryStatusAndAttendance() {
      if (!employeeId) {
        setSalaryStatus(false);
        setAttendanceData([]);
        return;
      }

      const now = new Date();
      
      // Always check previous month for salary status
      // If current month is December (12), use November (11) of same year
      // If current month is January (1), use December (12) of previous year
      const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const checkMonth = prevMonth.getMonth() + 1; // 1-12
      const checkYear = prevMonth.getFullYear();

      // First, get salary status for previous month
      let isCurrentMonthSalary = true;
      try {
        const res = await getRequest(
          `/api/monthlysalery/byEmployee/${employeeId}?month=${checkMonth}&year=${checkYear}`
        );
        
        if (res.data?.payrollRecords?.length === 0) {
          setSalaryStatus(false);
          isCurrentMonthSalary = false;
        } else {
          setSalaryStatus(true);
          isCurrentMonthSalary = true;
        }
      } catch (error) {
        console.error("Error fetching salary status:", error);
        setSalaryStatus(false);
        isCurrentMonthSalary = false;
      }

      // Fetch attendance for the month that PaySlip will display
      // If salaryStatus is true, PaySlip shows current month; if false, shows previous month
      let attendanceMonth, attendanceYear;
      if (isCurrentMonthSalary) {
        // PaySlip will show current month, so fetch current month attendance
        attendanceMonth = now.getMonth() + 1; // 1-12
        attendanceYear = now.getFullYear();
      } else {
        // PaySlip will show previous month, so fetch previous month attendance
        attendanceMonth = prevMonth.getMonth() + 1; // 1-12
        attendanceYear = prevMonth.getFullYear();
      }

      const attendanceMonthLastDay = new Date(attendanceYear, attendanceMonth, 0).getDate();
      const startDate = `${attendanceYear}-${String(attendanceMonth).padStart(2, "0")}-01`;
      const endDate = `${attendanceYear}-${String(attendanceMonth).padStart(2, "0")}-${String(attendanceMonthLastDay).padStart(2, "0")}`;

      try {
        const res = await getRequest(
          `/api/myattendance?employeeId=${employeeId}&startDate=${startDate}&endDate=${endDate}`
        );
        setAttendanceData(res?.attendanceLogs || []);
      } catch (error) {
        setAttendanceData([]);
      }
    }

    fetchSalaryStatusAndAttendance();
  }, []);

  // New useEffect to fetch team members data
  useEffect(() => {
    const employeeId = getEmployeeId();
    const fetchTeamMembers = async () => {
      try {
        const response = await getRequest(`/api/companies/teammembers?employeeId=${employeeId}`);
        setTeamData(response);
      } catch (error) {
        console.error('Error fetching team members:', error);
      }
    };

    fetchTeamMembers();
  }, []);


  return (
    <div className="grid grid-cols-1 gap-4 p-4 lg:grid-cols-12">
      {/* Profile Section */}
      {/* <div className="col-span-1 lg:col-span-3 bg-white py-2 border border-white rounded-md shadow-2xl  h-auto">
        <Suspense fallback={<UserCardSkeleton />}>
          <UserCard />
        </Suspense>
      </div> */}

      {/* Chart Section */}
      <div className="col-span-1 lg:col-span-12 bg-white p-4 rounded-md shadow-2xl ">
        <Chart />
      </div>

      {/* Attendance Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col">
        <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
          <Clock className="h-4 w-4" />
          ATTENDANCE
        </h3>
        <hr className=" border-gray-300" />
        <div className="flex-1 flex justify-center items-center">
          <AttendanceCard  />
        </div>
      </div>

      {/* Missing Entry Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col">
        <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
          <Clock className="h-4 w-4" />
          Missing Attendance
        </h3>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto overflow-x-hidden">
          <EntryTable attendanceData={attendanceData} />
        </div>
      </div>

      {/* Leave Summary Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col border border-gray-200">
        <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
          <SquareKanban className="h-4 w-4" /> Leave Summary
        </h3>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <LeaveTable />
        </div>
      </div>

      {/* Payslip Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col border border-gray-200">
        <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
          <NotebookIcon className="h-4 w-4" /> Payslip
        </h3>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <PaySlip attendanceData={attendanceData} salaryStatus={salaryStatus}/>
        </div>
      </div>

      {/* My Request Section */}
      <div className="col-span-1 lg:col-span-6 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col border border-gray-200">
        <div className="flex justify-between items-center px-2">
          <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
            <NotebookIcon className="h-4 w-4" /> Requests
          </h3>
        </div>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <RequestTable />
        </div>
      </div>

      {/* My Team Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-65 flex flex-col border border-gray-200">
        <div className="flex-1 max-h-full overflow-y-auto">
          <TeamTable teamData={teamData} />
        </div>
      </div>

      {/* News Section */}
      <div className="col-span-1 lg:col-span-3 bg-white rounded-md shadow-2xl h-auto min-h-60 flex flex-col border border-gray-200">
        <h3 className="text-md font-semibold text-primary flex items-center gap-2 py-2 px-2">
          <Volume2 className="h-4 w-4 -rotate-12" /> News
        </h3>
        <hr className=" border-gray-300" />
        <div className="flex-1 max-h-full overflow-y-auto">
          <Announce />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
